export default {
  myExam_score_total_score: '考试成绩{score}分/{totalScore}分',
  myExam_no_chance:'考试机会已用完',
  myExam_still:'还有{remainNum}次考试机会',
  myExam_exam_ended:"考试已结束",
  myExam_test_num:'共{testNum}题',
  myExam_current_tab:'还没有{currentTab}'
}
